import React from 'react';
import { Wrapper, Icon, Info, Title, Meta, Progress } from './styles';

interface Props {
  type: 'video' | 'pdf' | 'audio' | 'image';
  filename?: string | null;
  progress?: number | null;
}

const ICONS: Record<Props['type'], string> = {
  video: '🎬',
  pdf: '📄',
  audio: '🎵',
  image: '🖼️',
};

export const MediaUploadingPlaceholder: React.FC<Props> = ({
  type,
  filename,
  progress,
}) => {
  const icon = ICONS[type] ?? '📁';

  return (
    <Wrapper>
      <Icon>{icon}</Icon>
      <Info>
        <Title>{filename || `Subiendo ${type}...`}</Title>
        <Meta>{progress ?? 0}%</Meta>
      </Info>
      <Progress>⏳</Progress>
    </Wrapper>
  );
};

